import { Accordion, Container } from "react-bootstrap";
import SectionHeader from "../../components/SectionHeader";
import img from "../../images/services-16.jpg";

function CorporateEventInsurance() {

    return (
        <>

            <section className="service-page-bg">
                <SectionHeader title="Corporate Event Insurance" PageLink="Corporate Event Insurance" Image={img}></SectionHeader>
                <div className="service-page-main new-service-page-main">
                    <Container>
                        <div className="">
                            <h2>Corporate Event Insurance</h2>
                            <p className="strong_text_p">Professional Coverage for Every Business Occasion  </p>
                            <p>
                                Corporate events are more than just meetings and ceremonies. They are opportunities to showcase your company, connect with your team, and build stronger business relationships. From large conferences to small business meetings, every detail matters. But with so much at stake, even a minor disruption can create big problems.
                                <br />
                                Our <span className="strong_text">corporate event insurance </span> provides you with peace of mind, allowing you to focus on making your event a success. Whether you're planning a conference, an award ceremony, or a networking reception, we'll protect your event from unexpected risks and help ensure everything runs smoothly.
                            </p>

                            <p className="strong_text_p">Why Businesses Choose Us</p>
                            <p>
                                We understand the unique needs of professional events. With <span className="strong_text">conference insurance, business meeting insurance,</span>
                                and <span className="strong_text">award ceremony insurance,</span> we provide tailored coverage that meets the standards of venues and
                                reassures your stakeholders. Organizers can feel confident knowing that their event is protected, and attendees can focus on connecting
                                and enjoying the occasion.
                            </p>
                            <p className="strong_text_p">What We Cover </p>
                            <ul className="list_style_disc">
                                <li><span className="strong_text">Corporate Event Insurance</span> : Protects your company's functions, meetings, and celebrations.</li>
                                <li><span className="strong_text">Conference Insurance</span> : Ensures large gatherings and professional conferences are fully covered.</li>
                                <li><span className="strong_text">Business Meeting Insurance</span> : Safeguards smaller internal or client-focused meetings.</li>
                                <li><span className="strong_text">Award Ceremony Insurance</span> : Covers the risks of formal recognition events and galas.</li>
                                <li><span className="strong_text">Professional Event Liability Insurance</span> : Protects you if someone is injured or property is damaged during your event.</li>
                                <li><span className="strong_text">Seminar Insurance</span> : Supports learning-focused sessions and workshops.</li>
                                <li><span className="strong_text">Networking Event Insurance</span> : Ensures mixers, socials, and industry networking nights are worry-free.</li>
                                <li><span className="strong_text">Company Function Insurance</span> : Protects holiday parties, annual meetings, and corporate celebrations.</li>
                            </ul>
                            <p className="strong_text_p">How It Works </p>
                            <p>Getting <span className="strong_text">corporate event insurance </span> is quick and easy: </p>
                            <ul className="list_style_disc">
                                <li>Enter your event details</li>
                                <li>Get an instant quote</li>
                                <li>Buy your policy online</li>
                                <li>Download your Certificate of Insurance (COI) instantly</li>
                            </ul>
                            <div className="mb-5">
                                <h2 className="">FAQs</h2>
                                <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Do small company events need insurance?</Accordion.Header>
                                        <Accordion.Body>
                                            Yes. Even a simple business meeting can carry risks. Business meeting insurance ensures you're covered if an accident or damage occurs.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>Does corporate event insurance cover multiple days?</Accordion.Header>
                                        <Accordion.Body>
                                            Yes. Conference insurance and seminar insurance can be extended for multi-day or multi-session events.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>Will insurance meet venue requirements?</Accordion.Header>
                                        <Accordion.Body>
                                            Absolutely. Our professional event liability insurance is designed to satisfy venue rules and liability standards.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>Is coverage available for networking or holiday parties?</Accordion.Header>
                                        <Accordion.Body>
                                            Yes. We offer insurance for networking events and company functions, covering both formal and casual gatherings.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="4">
                                        <Accordion.Header>How soon can I get proof of coverage?</Accordion.Header>
                                        <Accordion.Body>
                                            Right away. Once your policy is purchased, your Certificate of Insurance (COI) is available instantly.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                </Accordion>
                            </div>
                            <p className="strong_text_p">Protect Your Next Corporate Event Today  </p>
                            <p>From conferences to award ceremonies, we've got you covered. Get an instant quote now and download your COI in minutes. </p>
                        </div>
                    </Container>
                </div>
            </section>
        </>
    );
}

export default CorporateEventInsurance;
